import { Page } from './../admin/models/page.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { httpParams } from '../../../core/_utils';
import { Observable } from 'rxjs';

const PAGES_API_URL = `${environment.apiPrefix}/pages`;

@Injectable({
  providedIn: 'root',
})
export class PageViewService {
  constructor(private http: HttpClient) {}

  getPageBySlug(slug: string): Observable<Page> {
    return this.http.get<Page>(PAGES_API_URL, { params: httpParams({ slug }) });
  }
}
